import React, { useRef } from 'react'
import { useMedia } from 'react-use'
import PropTypes from 'prop-types'
import { TweenMax } from 'gsap'
import globals from '../globals'

const NavBlock = (props) => {
    const container = useRef(null)
    const isMobile = useMedia('(max-width: 992px)')

    const handleClick = value => {
        globals.pushEvent('ChangeThreatsBlockedTab', { value: value })
        if (isMobile) {
            TweenMax.to(window, 0.5, { scrollTo: { y: container.current, offsetY: 50 } })
        }

        props.handleClick(value)
    }

    return (
        <div ref={container} className='nav-block'>
            {props.items.map((item, key) => {
                return (
                    <div
                        key={key}
                        className={`item ${props.activeItem === item.value ? 'active' : ''} ${props.className}`}
                        onClick={() => handleClick(item.value)}
                    >{item.title}
                    </div>
                )
            })}
        </div>
    )
}

NavBlock.propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape({
        title: PropTypes.string,
        value: PropTypes.string
    })).isRequired,
    handleClick: PropTypes.func.isRequired,
    activeItem: PropTypes.string,
    className: PropTypes.string
}

NavBlock.defaultProps = {
    className: ''
}

export default NavBlock



// WEBPACK FOOTER //
// ./resources/js/components/NavBlock.js